"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = void 0;
var Device;
(function (Device) {
    Device[Device["Desktop"] = 1] = "Desktop";
    Device[Device["Mobile"] = 2] = "Mobile";
})(Device = exports.Device || (exports.Device = {}));
